import { Icon } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import React from 'react'
import { Link } from 'react-router-dom'
import PrintBarcodeButton from '../../PrintBarcodeButton'
import GridSquare from '../GridSquare'
import { ProductListingProduct } from './types'
import { usePermissions } from '../../../hooks/usePermissions'

interface Props {
  product: ProductListingProduct
}

const ProductDetails = ({ product }: Props) => {
  const { includesAllPermissions } = usePermissions()

  return (
    <div className="item-details">
      <div className="drawer-header">
        <div>
          <Icon icon={IconNames.TAG} /> Product Details
        </div>
        {!product.unitTracking && <PrintBarcodeButton productId={product.id} productSkuLength={product.sku?.length} />}
      </div>
      <div className="details">
        <GridSquare title="SKU" contents={product.sku} />
        <GridSquare
          title="Product ID"
          contents={
            includesAllPermissions('products.view') ? (
              <Link to={`/products/${product.id}`}>{product.id}</Link>
            ) : (
              product.id
            )
          }
        />
        <GridSquare title="Location" contents={product.inventoryLocation && product.inventoryLocation.name} />
        <GridSquare title="Supplier" contents={product.supplier && product.supplier.name} />

        {product.manifest && (
          <GridSquare
            title="Manifest"
            contents={<Link to={`/manifests/${product.manifest.id}`}>{product.manifest.barcode}</Link>}
          />
        )}
        <GridSquare title="Listing Count" contents={product.productListings.length} />
      </div>
    </div>
  )
}

export default ProductDetails
